export const transformPhoneNumber = (phoneNumber: string, code: string) => {
  const phone = phoneNumber.replace(/\s/g, '');

  return `${code}${phone}`;
};
